
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Affordablecabserviceinmumbai() {



    const cardData =
    {
        keyword: 'Affordable cab service in Mumbai',
        heading: 'Skyline Cabs: Affordable cab service in Mumbai',
        headingDescription: 'Looking for an affordable cab service in Mumbai? Skyline Cabs provides budget-friendly, safe, and reliable travel options for local and outstation trips. Whether it is a daily commute, airport transfer, business travel, or a weekend getaway, we’ve got you covered with low fares and high comfort.​',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Affordable Cab Service in Mumbai",
      "description": "Skyline Cabs offers affordable cab services throughout Mumbai. Enjoy quality rides at competitive prices with professional drivers."
    },
    {
      "name": "Budget Taxi Service Mumbai",
      "description": "Looking for budget taxi options in Mumbai? Skyline Cabs delivers reliable and comfortable travel without overspending."
    },
    {
      "name": "Affordable Outstation Cabs Mumbai",
      "description": "Travel outstation from Mumbai at affordable rates with Skyline Cabs. Perfect for weekend getaways and long-distance journeys on a budget."
    },
    {
      "name": "Mumbai Budget Cab Booking",
      "description": "Easily book budget-friendly cabs in Mumbai with Skyline Cabs. Our seamless booking process and fair rates make travel easy and affordable."
    },
    {
      "name": "Affordable Mumbai Taxi Service",
      "description": "Skyline Cabs offers pocket-friendly taxi services across Mumbai. Enjoy low fares, safe rides, and professional service every time."
    }
  ],
  "tableData": [
    ["Affordable Cab Service in Mumbai", "Budget Taxi Service Mumbai"],
    ["Affordable Outstation Cabs Mumbai", "Mumbai Budget Cab Booking"],
    ["Affordable Mumbai Taxi Service"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Affordable Cab Service in Mumbai",
      "WhyChoosedescription": "Looking for a budget-friendly yet comfortable travel option in Mumbai? Our affordable cab service combines low fares with high-quality service for a smooth and economical ride."
    },
    {
      "WhyChooseheading": "Pocket-Friendly Rates with No Hidden Charges",
      "WhyChoosedescription": "Enjoy transparent pricing with no surprises. We offer straightforward and reasonable rates for all cab bookings across Mumbai."
    },
    {
      "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
      "WhyChoosedescription": "Ride in comfort with our clean, air-conditioned, and regularly serviced cabs—ideal for daily commutes, business meetings, or casual travel within the city."
    },
    {
      "WhyChooseheading": "Professional and Courteous Drivers",
      "WhyChoosedescription": "Our experienced drivers are polite, punctual, and committed to providing a safe and pleasant journey every time you ride with us."
    },
    {
      "WhyChooseheading": "Ideal for Local Rides, Airport Drops, and Outstation Trips",
      "WhyChoosedescription": "Whether you need a quick ride across town, a drop to the airport, or a weekend getaway, our affordable cabs are ready for all your travel needs."
    },
    {
      "WhyChooseheading": "Flexible Booking Options and Easy Payments",
      "WhyChoosedescription": "Book your cab online or by phone in minutes and choose from multiple payment modes including cash, UPI, and cards for maximum convenience."
    },
    {
      "WhyChooseheading": "Sanitized and Safe Travel",
      "WhyChoosedescription": "All our vehicles are sanitized before every ride and follow safety protocols, ensuring hygiene and peace of mind for every passenger."
    },
    {
      "WhyChooseheading": "24/7 Service Availability",
      "WhyChoosedescription": "Our affordable cab service is available around the clock. Whether it’s day or night, we’re ready to get you where you need to go, affordably and reliably."
    }
  ]
  
  
  
  
  
  








    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book an affordable cab service in Mumbai?',
            answer:
                'Booking an affordable cab service in Mumbai is easy. You can use apps like Ola Mini, Uber Go, or local Kaali Peeli taxis. Simply enter your pickup location in Mumbai, select your preferred vehicle, and confirm your booking through the app or customer support.',
        },
        {
            id: 2,
            question: 'What is the starting fare for affordable cabs in Mumbai?',
            answer:
                'The starting fare for affordable cabs like Ola Mini and Uber Go in Mumbai is generally around ₹25-₹30 for the first 2-3 km. After that, fares increase based on the distance traveled.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for affordable cab services in Mumbai?',
            answer:
                'For affordable cab services in Mumbai, you can opt for vehicles such as Tata Indica, Swift Dzire, or smaller hatchbacks. Services like Ola Mini and Uber Go provide these affordable vehicle options for short to medium trips.',
        },
        {
            id: 4,
            question: 'Are the fares for affordable cabs in Mumbai fixed or metered?',
            answer:
                'The fares for affordable cabs in Mumbai are generally metered. Services like Ola Mini and Uber Go calculate fares based on the distance traveled, using a dynamic pricing model that may fluctuate depending on demand.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab with affordable services in Mumbai?',
            answer:
                'Yes, both Ola and Uber offer one-way cab bookings in Mumbai, which means you can book a ride from your pickup location to your destination without the need for a return trip.',
        },
        {
            id: 6,
            question: 'Can I pay in cash for affordable cabs in Mumbai?',
            answer:
                'Yes, cash payment is accepted for most affordable cab services like local Kaali Peeli taxis. Ola and Uber also accept cash payments, but they encourage digital payments for convenience.',
        },
        {
            id: 7,
            question: 'Can I cancel or modify my booking for an affordable cab in Mumbai?',
            answer:
                'Yes, you can cancel or modify your booking through the Ola or Uber app. Cancellation charges may apply depending on the type of ride you booked.',
        },
        {
            id: 8,
            question: 'Are there any discounts or offers on affordable cabs in Mumbai?',
            answer:
                'Yes, both Ola and Uber often have promotional offers, discount codes, and referral programs to make your ride more affordable. Keep an eye out for special deals in the app to save on fares.',
        },
        {
            id: 9,
            question: 'Is it safe to use affordable cab services in Mumbai?',
            answer:
                'Yes, affordable cab services like Ola, Uber, and local taxis ensure passenger safety. They offer secure payment methods, real-time tracking, and background-checked drivers to ensure a safe travel experience.',
        },
        {
            id: 10,
            question: 'Why should I choose affordable cab services in Mumbai?',
            answer:
                'Affordable cab services in Mumbai are perfect for budget-conscious travelers. These services offer reliable transportation, flexible booking options, and transparent pricing, making them an excellent choice for both short trips and daily commutes around the city.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Mehta",
            rating: 5,
            review: "I booked an Ola Mini for a trip across Mumbai. The ride was comfortable, and the fare was very affordable. It’s the perfect option for anyone looking to save money while traveling around the city!"
        },
        {
            name: "Miss. Sneha Rani",
            rating: 4,
            review: "Uber Go is a great option for budget travel. The ride was smooth, and the fare was reasonable. Would love it if there were more offers for regular users."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Affordable Cab Service in Mumbai",
  "image": "https://skylinecabs.com/assets/images/affordable-cab-service-mumbai.jpg",
  "description": "Book Affordable Cab Service in Mumbai with Skyline Cabs for smooth, reliable, and pocket-friendly city or outstation travel. Enjoy AC hatchbacks, sedans, and SUVs with 24/7 availability and fixed transparent pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8743"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "249",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/affordable-cab-service-in-mumbai"
  }
};



      
      
      


    return (
        <div>
<Helmet>
  <title>Affordable Cab Service in Mumbai | Budget Taxi 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Affordable Cab Service in Mumbai with Skyline Cabs for smooth, reliable, and pocket-friendly city or outstation travel. Enjoy AC hatchbacks, sedans, and SUVs with 24/7 availability and fixed transparent pricing." 
  />
  <meta 
    name="keywords" 
    content="Affordable Cab Service in Mumbai, Budget Taxi Mumbai, Cheap Fare Cab Mumbai, Mumbai Local Taxi, Online Cab Booking Mumbai, 24/7 Cab Mumbai, AC Hatchback Mumbai Cab, Skyline Cabs Mumbai, SUV Cab at Low Price, Sedan Taxi Affordable Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/111.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Affordablecabserviceinmumbai;